import {
    SET_TRATAMIENTO,
    SET_SEXO,
    SET_NOMBRE_PRUEBA_DE_MANEJO,
    SET_APELLIDO_PATERNO_PRUEBA_DE_MANEJO,
    SET_ESTADO_PRUEBA_DE_MANEJO,
    SET_CIUDAD_PRUEBA_DE_MANEJO,
    SET_ID_CONCESIONARIO_PRUEBA_DE_MANEJO,
    SET_CONCESIONARIO_PRUEBA_DE_MANEJO,
    SET_TELEFONO_PRUEBA_DE_MANEJO,
    SET_MOVIL_PRUEBA_DE_MANEJO,
    SET_CORREO_PRUEBA_DE_MANEJO,
    SET_MODELO_DEL_VEHICULO_PRUEBA_DE_MANEJO,
    SET_MARCA_DEL_VEHICULO_PRUEBA_DE_MANEJO,
    SET_VEHICULO_INTERES_PRUEBA_DE_MANEJO,
    SET_COMENTARIOS_PRUEBA_DE_MANEJO,
    SET_AVISO_PRIVACIDAD_PRUEBA_DE_MANEJO,
    SET_URL_HOME_DEALER_PRUEBA_DE_MANEJO,
    RESET_STATE_PRUEBA_DE_MANEJO,
} from "../types";

const initialState = {
    nombre: "",
    apellidoPaterno: "",
    telefono: "",
    celular: "",
    email: "",
    ciudad: "",
    estado: "",
    tratamiento: "Sr",
    sexo:"Masculino",
    numeroConcesionaria: "",
    concesionariaPreferida: "",
    modeloVehiculo: "",
    marcaVehiculo: "",
    vehiculoInteres: "",
    descripcion: "",
    avisoPrivacidad: false,
    urlHomeDealer: "https://www.audi.com.mx/mx/web/es.html",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case SET_TRATAMIENTO:
            return {
                ...state,
                tratamiento: action.payload,
            };
        case SET_SEXO:
            return {
                ...state,
                sexo: action.payload,
            };
        case SET_NOMBRE_PRUEBA_DE_MANEJO:
            return {
                ...state,
                nombre: action.payload,
            };
        case SET_APELLIDO_PATERNO_PRUEBA_DE_MANEJO:
            return {
                ...state,
                apellidoPaterno: action.payload,
            };
        case SET_ESTADO_PRUEBA_DE_MANEJO:
            return {
                ...state,
                estado: action.payload,
            };
        case SET_CIUDAD_PRUEBA_DE_MANEJO:
            return {
                ...state,
                ciudad: action.payload,
            };
        case SET_ID_CONCESIONARIO_PRUEBA_DE_MANEJO:
            return {
                ...state,
                numeroConcesionaria: action.payload,
            };
        case SET_CONCESIONARIO_PRUEBA_DE_MANEJO:
            return {
                ...state,
                concesionariaPreferida: action.payload,
            };
        case SET_TELEFONO_PRUEBA_DE_MANEJO:
            return {
                ...state,
                telefono: action.payload,
            };
        case SET_MOVIL_PRUEBA_DE_MANEJO:
            return {
                ...state,
                celular: action.payload,
            };
        case SET_CORREO_PRUEBA_DE_MANEJO:
            return {
                ...state,
                email: action.payload,
            };
        case SET_MODELO_DEL_VEHICULO_PRUEBA_DE_MANEJO:
            return {
                ...state,
                modeloVehiculo: action.payload,
            };
        case SET_MARCA_DEL_VEHICULO_PRUEBA_DE_MANEJO:
            return {
                ...state,
                marcaVehiculo: action.payload,
            };
        case SET_VEHICULO_INTERES_PRUEBA_DE_MANEJO:
            return {
                ...state,
                vehiculoInteres: action.payload,
            };
        case SET_COMENTARIOS_PRUEBA_DE_MANEJO:
            return {
                ...state,
                descripcion: action.payload,
            };
        case SET_AVISO_PRIVACIDAD_PRUEBA_DE_MANEJO:
            return {
                ...state,
                avisoPrivacidad: action.payload,
            };
        case SET_URL_HOME_DEALER_PRUEBA_DE_MANEJO:
            return {
                ...state,
                urlHomeDealer: action.payload,
            };
        case RESET_STATE_PRUEBA_DE_MANEJO:
            return initialState;
        default:
            return state;
    }
}
